/**
 * Datos de ejemplo del módulo de evaluaciones de proveedores.
 *
 * Las tres pantallas de evaluaciones están ruteadas pero no hacen una sola
 * petición: su backend no existe. Los datos viven aquí, y no dentro de las
 * pantallas, para que se vea de un vistazo qué parte del sistema todavía es
 * maqueta y para que borrarlos cuando llegue el backend sea borrar un archivo.
 *
 * Las pantallas que los usan lo avisan con `DatosDeEjemploBanner`.
 */

export interface Evaluation {
  id: string;
  supplier: string;
  rfc: string;
  evaluatedPeriod: string;
  project: string;
  finalRating: string;
}

export const mockEvaluations: Evaluation[] = [
  {
    id: "1",
    supplier: "NombreProveedor",
    rfc: "DURG850719HDFRRL05",
    evaluatedPeriod: "11/2025",
    project: "Nombreproyecto",
    finalRating: "Nombreproyecto",
  },
  {
    id: "2",
    supplier: "NombreProveedor",
    rfc: "DURG850719HDFRRL05",
    evaluatedPeriod: "11/2025",
    project: "Nombreproyecto",
    finalRating: "Nombreproyecto",
  },
  {
    id: "3",
    supplier: "NombreProveedor",
    rfc: "DURG850719HDFRRL05",
    evaluatedPeriod: "11/2025",
    project: "Nombreproyecto",
    finalRating: "Nombreproyecto",
  },
  {
    id: "4",
    supplier: "NombreProveedor",
    rfc: "DURG850719HDFRRL05",
    evaluatedPeriod: "11/2025",
    project: "Nombreproyecto",
    finalRating: "Nombreproyecto",
  },
  {
    id: "5",
    supplier: "NombreProveedor",
    rfc: "DURG850719HDFRRL05",
    evaluatedPeriod: "11/2025",
    project: "Nombreproyecto",
    finalRating: "Nombreproyecto",
  },
  {
    id: "6",
    supplier: "NombreProveedor",
    rfc: "DURG850719HDFRRL05",
    evaluatedPeriod: "11/2025",
    project: "Nombreproyecto",
    finalRating: "Nombreproyecto",
  },
  {
    id: "7",
    supplier: "NombreProveedor",
    rfc: "DURG850719HDFRRL05",
    evaluatedPeriod: "11/2025",
    project: "Nombreproyecto",
    finalRating: "Nombreproyecto",
  },
  {
    id: "8",
    supplier: "NombreProveedor",
    rfc: "DURG850719HDFRRL05",
    evaluatedPeriod: "11/2025",
    project: "Nombreproyecto",
    finalRating: "Nombreproyecto",
  },
  {
    id: "9",
    supplier: "NombreProveedor",
    rfc: "DURG850719HDFRRL05",
    evaluatedPeriod: "11/2025",
    project: "Nombreproyecto",
    finalRating: "Nombreproyecto",
  },
];

export interface EvaluationCriteria {
  id: number;
  name: string;
  score: number;
}

export interface EvaluationDetailData {
  id: string;
  supplier: string;
  rfc: string;
  evaluator: string;
  evaluationDate: string;
  period: string;
  project: string;
  criteria: EvaluationCriteria[];
  generalComments: string;
  finalRating: number;
  maxRating: number;
}

export const mockEvaluation: EvaluationDetailData = {
  id: '1',
  supplier: 'NombreProveedor',
  rfc: 'DURG850719HDFRRL05',
  evaluator: 'Kevin Castillo',
  evaluationDate: '02/12/2025',
  period: '11/2025',
  project: 'NombreProyecto',
  criteria: [
    { id: 1, name: 'Entregas en tiempo', score: 4 },
    { id: 2, name: 'Calidad del servicio / producto', score: 3 },
    { id: 3, name: 'Cumplimiento documental', score: 2 },
    { id: 4, name: 'Comunicación y respuesta', score: 3 },
    { id: 5, name: 'Incidencias y reportes', score: 4 },
  ],
  generalComments: 'Lorem ipsum dolor sit amet consectetur. Sagittis scelerisque tortor feugiat eget leo tortor sem. Nam cursus molestie et facilisi feugiat. Ac blandit vitae tempor eget arcu. Pellentesque tellus penatibus duis in nibh.',
  finalRating: 3.2,
  maxRating: 5,
};
